import { and, setup } from 'xstate';

import { AdjustInitializationActions } from './adjust-initialization-machine.actions';
import { type AdjustEvent } from './adjust-initialization-machine.events';
import { AdjustInitializationGuards } from './adjust-initialization-machine.guards';

export const adjustInitializationMachine = setup({
  types: { events: {} as AdjustEvent },
  actions: AdjustInitializationActions,
  guards: AdjustInitializationGuards,
}).createMachine({
  initial: 'waiting',
  states: {
    waiting: {
      on: {
        SYNC_CUSTOMER: {
          guard: and(['isAdjustEnabled', 'isTrackingAllowed']),
          target: 'ready',
          actions: ['initialize', 'enable', 'syncCustomer'],
        },
      },
    },
    ready: {
      on: {
        SYNC_CUSTOMER: [
          {
            guard: and(['isAdjustEnabled', 'isTrackingAllowed']),
            actions: ['syncCustomer'],
          },
          {
            target: 'disabled',
            actions: ['clearCustomer', 'disable'],
          },
        ],
      },
    },
    disabled: {
      on: {
        SYNC_CUSTOMER: {
          guard: and(['isAdjustEnabled', 'isTrackingAllowed']),
          target: 'ready',
          actions: ['enable', 'syncCustomer'],
        },
      },
    },
  },
});
